import axios from "axios";
import { requiredParam } from "@utils/func";

const getPatent = ({ patentId = requiredParam("patentId") } = {}) => {
  return axios.get(`patents/${patentId}`);
};

const patchPatent = ({
  patentId = requiredParam("patentId"),
  data = requiredParam("data"),
} = {}) => {
  return axios.patch(`patents/${patentId}`, data);
};

export { getPatent, patchPatent };
